module.exports = __webpack_public_path__ + "static/media/no-notifications.fb24fd60.svg";